import Route from '@ember/routing/route';

export default class DataManagerAutoConnectRoute extends Route {}
